import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiArrowRight } = FiIcons;

const RequestCare = () => (
  <>
    <Helmet>
      <title>Request Care | KCG</title>
      <meta name="description" content="Speak with KCG about arranging home care. Call or email us for an initial conversation about the support you need." />
      <link rel="canonical" href="https://kcg.care/request-care" />
    </Helmet>
    <section className="bg-gradient-to-br from-primary-50 to-secondary-50 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-primary-900 font-semibold mb-4">Starting care</p>
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">Let’s talk about care</h1>
        <p className="text-xl text-gray-700 leading-relaxed">Contact our team for an initial conversation. We will ask about the area, the support you have in mind and the best way to follow up.</p>
      </div>
    </section>
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-2 gap-6">
          <a href="tel:03333394077" className="rounded-2xl border border-primary-100 bg-primary-50 p-8 hover:shadow-lg transition-shadow">
            <SafeIcon icon={FiPhone} className="w-9 h-9 text-primary-900 mb-5" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Call 03333 394 077</h2>
            <p className="text-gray-600">Talk through your enquiry with us.</p>
          </a>
          <a href="mailto:enquiries@odaracare.org.uk?subject=Care%20enquiry" className="rounded-2xl border border-primary-100 bg-primary-50 p-8 hover:shadow-lg transition-shadow">
            <SafeIcon icon={FiMail} className="w-9 h-9 text-primary-900 mb-5" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Email our team</h2>
            <p className="text-primary-900 font-semibold break-all">enquiries@odaracare.org.uk</p>
          </a>
        </div>
        <p className="mt-8 text-gray-600">Please keep your first message brief and avoid sending medical records or medication details by ordinary email. We can discuss a suitable way to share further information if needed.</p>
        <Link to="/where-we-operate" className="mt-8 inline-flex items-center text-primary-900 font-semibold hover:underline">See our service areas <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" /></Link>
      </div>
    </section>
  </>
);

export default RequestCare;
